import axios from "axios";
import {getToken} from "@/api/config/token"
import {getAPIbaseURL, getEntidade} from "@/api/config/init"
import Swal from "sweetalert2";
//import {authMethods} from '@/state/helpers'
import store from '@/state/store'
import router from "@/router";
import appConfig from "@/dados/app.config.json";

// create an axios instance
const service = axios.create({
    baseURL: getAPIbaseURL(),
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 900000 // 15 minutos
});

// request interceptor
service.interceptors.request.use(
    config => {
        config.headers['X-ACCESS-ENTIDADE'] = getEntidade();
        config.headers['X-ACCESS-TOKEN'] = getToken();
        return config
    },
    error => {
        return Promise.reject(error)
    }
);


service.interceptors.response.use(
    response => {
        //const {data, status} = response;
        //console.log(status);
        const {data, headers} = response;
        //console.log(response);
        /*
        if (!data.status) {
          return Promise.reject(new Error(data.mensagem || 'Error'))
        } else {
          if (status === 201) {
             console.log(data)
          }
          return data
        }*/
        //verificar se o sistema está desatualizado
        const versaoApi = headers['x-api-version']
        const versaoFront = appConfig.versao;
        if(versaoApi!==versaoFront){
            Swal.fire({
                title: "Nova Atualização Disponível",
                html: "Para evitar inconsistência na base de dados é recomendado atualizar imediatamente. <br> Os dados digitados não salvos serão perdidos.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                confirmButtonText: "Atualizar agora",
                cancelButtonText:"Mais tarde",
            }).then(result => {
                if (result.isConfirmed) {
                    window.location.reload()
                }
            });
        }
        return data
    },
    error => {
        if (typeof error.response === "undefined") {
            return Promise.reject(error);
        }

        const {data, status} = error.response;

        const rout = router.currentRoute;

        if (status === 401 && rout.name !== 'index') {
            Swal.fire({
                title: data.mensagem,
                html: "Seu acesso expirou. <br> Faça o login novamente para continuar acessando.",
                icon: "warning",
                showCancelButton: false,
                confirmButtonColor: "#9a9d9c",
                confirmButtonText: "Fazer Login"
            }).then(result => {
                if (result.isConfirmed) {
                    store.dispatch('auth/logOut').catch(error => {
                        console.log(error)
                    })
                }
            });
        }
        return Promise.reject(error);
    }
);

export default service
